import React from 'react';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Section from 'components/Section';
import { Container } from 'react-bootstrap';

const MainActivitiesPage = () => {
    return (
        <>
            <Header />
            <Section
                scheme="white"
                paddingVertical="pt-5"
            >
                <Container>
                    <div className="page-title">
                        Các Hoạt Động Chính của Chi Hội Tim Mạch Can Thiệp
                        Mekong (MICA)
                    </div>
                    <div className="mt-4 page-content">
                        <div className="sub-heading">
                            Đào Tạo và Phát Triển Nguồn Nhân Lực
                        </div>
                        <div>
                            Chi hội Tim mạch Can thiệp Mekong (MICA) chú trọng
                            việc xây dựng và phát triển nguồn nhân lực chất
                            lượng cao nhằm đáp ứng nhu cầu ngày càng tăng về
                            chăm sóc và điều trị bệnh tim mạch. Mục tiêu cụ thể
                            là đào tạo ít nhất 80% bác sĩ trong khu vực đạt
                            chuẩn chuyên môn về tim mạch can thiệp thông qua:
                            <ul>
                                <li>
                                    Tổ chức thường xuyên các khóa học cơ bản,
                                    nâng cao và chuyên sâu với sự tham gia giảng
                                    dạy của các chuyên gia đầu ngành trong và
                                    ngoài nước.
                                </li>
                                <li>
                                    Phát triển một trung tâm đào tạo hiện đại,
                                    ứng dụng các kỹ thuật tim mạch can thiệp
                                    tiên tiến nhất, là địa điểm đào tạo thực
                                    hành hàng đầu trong khu vực.
                                </li>
                                <li>
                                    Hợp tác chiến lược với các trường đại học y
                                    khoa, viện nghiên cứu và trung tâm đào tạo
                                    uy tín để xây dựng chương trình đào tạo đạt
                                    tiêu chuẩn quốc tế.
                                </li>
                                <li>
                                    Cấp chứng chỉ đào tạo liên tục (CME) nhằm
                                    thúc đẩy và nâng cao năng lực chuyên môn và
                                    cập nhật kiến thức cho đội ngũ bác sĩ.
                                </li>
                            </ul>
                        </div>
                        <div className="sub-heading">
                            Nghiên Cứu Khoa Học và Ứng Dụng Công Nghệ
                        </div>
                        <div>
                            Nghiên cứu khoa học và ứng dụng các tiến bộ công
                            nghệ vào thực tiễn y tế là một trong những ưu tiên
                            hàng đầu của MICA:
                            <ul>
                                <li>
                                    Hàng năm thực hiện tối thiểu 5 nghiên cứu
                                    lâm sàng chất lượng cao và công bố ít nhất
                                    20 bài báo khoa học trên các tạp chí y khoa
                                    quốc tế.
                                </li>
                                <li>
                                    Tiên phong ứng dụng các công nghệ tiên tiến
                                    như trí tuệ nhân tạo (AI), robot hỗ trợ can
                                    thiệp tim mạch, và các giải pháp kỹ thuật số
                                    vào chẩn đoán và điều trị bệnh tim mạch.
                                </li>
                                <li>
                                    Thực hiện các nghiên cứu chuyên sâu về tác
                                    động của yếu tố môi trường, thói quen sinh
                                    hoạt và chế độ dinh dưỡng lên nguy cơ mắc
                                    các bệnh lý tim mạch.
                                </li>
                                <li>
                                    Phát triển và hoàn thiện cơ sở dữ liệu khu
                                    vực về bệnh nhân tim mạch nhằm phục vụ
                                    nghiên cứu và tối ưu hóa các phương pháp
                                    điều trị cá nhân hóa.
                                </li>
                                <li>
                                    Đẩy mạnh hợp tác quốc tế trong nghiên cứu
                                    khoa học với các trung tâm nghiên cứu và
                                    bệnh viện lớn trên thế giới để không ngừng
                                    nâng cao chất lượng nghiên cứu và ứng dụng
                                    thực tiễn.
                                </li>
                            </ul>
                        </div>
                        <div className="sub-heading">
                            Hợp Tác Quốc Tế và Chuyển Giao Công Nghệ
                        </div>
                        <div>
                            Nhằm nâng cao chất lượng dịch vụ y tế và cập nhật
                            nhanh nhất các tiến bộ khoa học công nghệ, MICA tập
                            trung vào:
                            <ul>
                                <li>
                                    Ký kết ít nhất 5 thỏa thuận hợp tác chiến
                                    lược mỗi năm với các tổ chức y tế, bệnh viện
                                    và trung tâm nghiên cứu hàng đầu quốc tế và
                                    trong nước.
                                </li>
                                <li>
                                    Tổ chức định kỳ các hoạt động trao đổi học
                                    thuật, chương trình đào tạo chuyên biệt, các
                                    buổi hội thảo và tập huấn thực hành kỹ thuật
                                    mới nhất trong lĩnh vực tim mạch can thiệp.
                                </li>
                                <li>
                                    Phát triển các mô hình hợp tác công-tư hiệu
                                    quả để huy động nguồn lực và tối ưu hóa việc
                                    chuyển giao công nghệ mới vào hệ thống y tế.
                                </li>
                                <li>
                                    Tổ chức các hội nghị khoa học thường niên
                                    quốc tế, thu hút sự tham gia và chia sẻ của
                                    các chuyên gia hàng đầu thế giới nhằm thúc
                                    đẩy giao lưu và cập nhật kiến thức mới.
                                </li>
                            </ul>
                        </div>
                        <div className="sub-heading">
                            Chăm Sóc Sức Khỏe Cộng Đồng
                        </div>
                        <div>
                            MICA cam kết thực hiện trách nhiệm xã hội qua các
                            hoạt động cộng đồng thiết thực như:
                            <ul>
                                <li>
                                    Hàng năm tổ chức ít nhất 5 chương trình khám
                                    bệnh lưu động, chủ động tiếp cận ít nhất
                                    50.000 người dân tại các khu vực vùng sâu,
                                    vùng xa, khó tiếp cận dịch vụ y tế cơ bản.
                                </li>
                                <li>
                                    Cung cấp miễn phí thuốc men, hỗ trợ chi phí
                                    điều trị cho tối thiểu 200 bệnh nhân nghèo
                                    hoặc hoàn cảnh đặc biệt khó khăn mỗi năm.
                                </li>
                                <li>
                                    Thực hiện các chiến dịch truyền thông nâng
                                    cao nhận thức về bệnh tim mạch, khuyến khích
                                    người dân thay đổi lối sống và có biện pháp
                                    phòng ngừa hiệu quả thông qua mạng xã hội,
                                    hội thảo trực tuyến và các phương tiện
                                    truyền thông đại chúng.
                                </li>
                                <li>
                                    Tăng cường hợp tác với các tổ chức phi chính
                                    phủ trong và ngoài nước để triển khai các
                                    chương trình hỗ trợ y tế bền vững và hiệu
                                    quả cho cộng đồng.
                                </li>
                            </ul>
                        </div>
                        <div className="pt-5">
                            Thông qua các hoạt động đa dạng và toàn diện trên,
                            MICA hướng tới mục tiêu cải thiện toàn diện sức khỏe
                            tim mạch cho cộng đồng, góp phần xây dựng một hệ
                            thống y tế hiện đại, hội nhập và hiệu quả.
                        </div>
                    </div>
                    <hr className="mt-4 footer-divider" />
                </Container>
            </Section>
            <Footer />
        </>
    );
};

export default MainActivitiesPage;
